// extracted by mini-css-extract-plugin
export default {"relative":"MediaAddButton_relative__QU0vM","add":"MediaAddButton_add__Dmsep"};